import React, { useState } from "react";
import StepName from "../components/createAirlineWizard/StepName.jsx";
import StepLogo from "../components/createAirlineWizard/StepLogo.jsx";
import StepColors from "../components/createAirlineWizard/StepColors.jsx";
import StepLivery from "../components/createAirlineWizard/StepLivery.jsx";
import StepHub from "../components/createAirlineWizard/StepHub.jsx";
import WizardLayout from "../components/createAirlineWizard/WizardLayout.jsx";

export default function CreateAirlineWizard() {
  const [step, setStep] = useState(1);
  const [form, setForm] = useState({
    name: "",
    iata: "",
    logoId: null,
    colors: { primary: "#00ffbf", accent: "#0088ff" },
    liveryId: null,
    hub: null
  });

  const next = () => setStep((s) => Math.min(5, s + 1));
  const back = () => setStep((s) => Math.max(1, s - 1));

  const steps = {
    1: <StepName form={form} setForm={setForm} next={next} />,
    2: <StepLogo form={form} setForm={setForm} next={next} back={back} />,
    3: <StepColors form={form} setForm={setForm} next={next} back={back} />,
    4: <StepLivery form={form} setForm={setForm} next={next} back={back} />,
    5: <StepHub form={form} setForm={setForm} back={back} />
  };

  return <WizardLayout step={step}>{steps[step]}</WizardLayout>;
}